import(/* webpackMode: "eager" */ "/opt/fructidor/fructidor-ui/releases/20250516143428/app/[lng]/(home)/pre-post-harvest/[id]/layout.tsx");
